import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { routesPath } from '@router/routes';
import { PageLoading } from '@dynamika-shared/ui/PageLoading/PageLoading';

export const SubjectListEntryPage = () => {
  const { id: clinicalTrialId } = useParams<{
    id: string;
  }>();

  const contextData = useClinicalTrialContextSlice(state => state.data);
  const navigate = useNavigate();

  useEffect(() => {
    if (contextData?.configuration?.id && clinicalTrialId === contextData.configuration.id) {
      const _siteId = contextData?.affiliatedSiteList?.[0]?.id;
      navigate(`${routesPath.subjectBase}/${clinicalTrialId}/${_siteId}`);
    }
  }, [contextData, clinicalTrialId]);

  return <PageLoading className='w-full h-[70vh]' />;
};
